import {
  getPumps, postPump, putPump, exportPumps, importPumps,
} from '../../../Api/services/backoffice';

export const key = 'pump';

const entityName = {
  singular: 'Bomba',
  plural: 'Bombas',
};

const queries = {
  list: { key, fn: getPumps },
  detail: { key },
};

const mutations = {
  create: postPump,
  update: putPump,
};

const fields = {
  table: [
    { key: 'code', label: 'Código' },
    { key: 'name', label: 'Nome' },
    { key: 'status', label: 'Status', mustRender: { componentType: 'status' } },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
  showBatchButton: true,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};

export const batchConfig = {
  entityName: entityName.plural,
  exportFn: exportPumps,
  importFn: importPumps,
};
